import { ApiClient } from '../../api-client/api-client';
import {
  DesignFileSearchParams,
  DocumentSearchParams,
  EmailSearchParams,
} from '../../api-client/autogenerated';

export const searchDocuments = async (
  projectId: string,
  params: DocumentSearchParams,
  page = 0,
  pageSize = 200,
) => {
  return ApiClient.searchDocuments({
    projectId,
    documentSearchParams: params,
    page,
    pageSize,
  }).then((res) => res.data);
};

export const searchEmails = async (
  projectId: string,
  params: EmailSearchParams,
  page = 0,
  pageSize = 200,
) => {
  return ApiClient.searchEmails({ projectId, emailSearchParams: params, page, pageSize }).then(
    (res) => res.data,
  );
};

export const searchDesignFiles = async (
  projectId: string,
  params: DesignFileSearchParams,
  page = 0,
  pageSize = 200,
) => {
  return ApiClient.searchDesignFiles({
    projectId,
    designFileSearchParams: params,
    page,
    pageSize,
  }).then((res) => res.data);
};
